import useSignatureUpload from '../../../../hooks/useSignatureUpload';
import XLoader from '../../../../components/common/XLoader';
import XModal from '../../../../components/common/XModal';
import SignaturePreviewCard from './SignaturePreviewCard';
import SignatureDropzone from './SignatureDropzone';
import SignatureRules from './SignatureRules';

const sectionClasses = 'rounded-lg bg-surface-alt p-6 mb-12';
const contentStackClasses = 'flex flex-col gap-4';

const SignatureUploadSection = () => {
  const {
    signature,
    isLoading,
    isUploading,
    onFileSelect,
    removeSignature,
    downloadSignature,
    confirmation
  } = useSignatureUpload();

  return (
    <>
      <div className="title">
        <h2>Signature</h2>
      </div>
      <div className={sectionClasses}>
        {isLoading ? (
          <XLoader />
        ) : (
          <div className={contentStackClasses}>
            {signature?.viewUrl && (
              <SignaturePreviewCard
                signature={signature}
                isUploading={isUploading}
                onDownload={downloadSignature}
                onRemove={removeSignature}
              />
            )}
            <SignatureDropzone
              message={signature?.viewUrl
                ? 'Upload a new PNG to replace your current signature.'
                : 'Upload your signature image to use in finalized Lifecare Plans.'}
              disabled={isUploading}
              onFileSelect={onFileSelect}
            />
            <SignatureRules />
          </div>
        )}
      </div>

      {confirmation?.type === 'delete' && (
        <XModal
          isOpen={confirmation.isOpen}
          title="Remove signature?"
          subtitle="Your saved signature will be removed."
          onClose={confirmation.onCancel}
          onSubmit={confirmation.onConfirm}
          submitText="Remove"
          cancelText="Cancel"
          size="sm"
          isSubmitting={isUploading}
        />
      )}
    </>
  );
};

export default SignatureUploadSection;
